<script setup lang="ts">
const props = defineProps<{
    title: string,
    desc: string,
}>();
</script>

<template>
    <SectionsBase>
        <div class="background">
            <div class="container relative z-1">
                <div class="w-full bg-white p-8 rounded-3xl shadow-primary-l">
                    <div class="w-full flex justify-center items-center gap-3 mb-8">
                        <IconsLine class="hidden lg:block bg-linear-to-r from-warning-700 to-warning-200" />
                        <h2 class="h3">{{ props.title }}</h2>
                        <IconsLine class="hidden lg:block rotate-180 bg-linear-to-r from-warning-700 to-warning-200" />
                    </div>
                    <p class="text-body2 text-gray-500 text-center">{{ props.desc }}</p>
                </div>
            </div>
        </div>
    </SectionsBase>
</template>

<style scoped>
@reference "~/assets/css/main.css";

.background {
    @apply
    relative bg-linear-to-b from-transparent via-primary-100 to-transparent py-8 lg:py-16
}
.background::before {
    @apply
    content-[''] absolute w-full h-full top-0 right-0 bg-[url('/svg/new/backgrounds/mesh-09.svg')] bg-no-repeat 
    bg-bottom lg:bg-size-[100%_auto]
}
</style>